import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { Profile } from '../../../store/commonTypes'

import { Link } from '../../../i18next/helpers'

import { genders } from '../../../constants'
import paths from '../../../paths'

import { setIsLeavingPage } from '../../../store/common/commonSlice'
import { useDispatch } from 'react-redux'

import s from './profilePreview.module.sass'
import { memo, useRef } from 'react'

interface Props {
    profile: Profile
}

const ProfilePreview: React.FunctionComponent<Props> = ({ profile }: Props) => {
    const ref = useRef(null)
    const [t] = useTranslation()
    const dispatch = useDispatch()
    return (
        <Link
            to={paths.profile.toPath({ nick: profile.nick })}
            className={s['profilePreview']}
            onClick={() => dispatch(setIsLeavingPage(true))}
        >
            <div className={s['avatar']}>
                <img
                    ref={ref}
                    className={s['avatar__image']}
                    src={profile.avatar_url}
                    alt=""
                    onError={() => (ref.current.src = require('./../../../assets/404.png'))}
                />
            </div>
            <div className={s['info']}>
                <div className={profile.is_online ? s['info__nick'] + s['info__nick_online'] : s['info__nick']}>
                    {profile.nick}
                </div>
                <ul className={s['info__stat']}>
                    {!!profile.gender && <li>{t(genders.filter((item) => item.value === profile.gender)[0].label)}</li>}
                    {profile.age > 0 && (
                        <li>
                            {profile.age} {t('years')}
                        </li>
                    )}
                </ul>
            </div>
        </Link>
    )
}

export default memo(ProfilePreview)
